/**
 * The time in minutes that after it passes - the message expires and the popup closes
 */
export const MESSAGE_EXPIRE_MINUTES = 5;

/**
 * After the user closes the popup this number of times - it won't show up again
 */
export const MAX_CLOSED_MESSAGES = 4;

/**
 * Page element name in BI events
 */
export const PAGE_ELEMENT_NAME = 'five_minutes_response_banner';

/**
 * State metadata for BI events
 */
export const STATE = {
    EXPANDED: 'expanded',
    MINIMIZED: 'minimized',
};
